import React from "react";

import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import CircularProgress from "../../../../components/CircularProgress";
import { Tooltip } from "../../../../components";
import { ReactComponent as LockIcon } from "../../../../assets/lock.svg";
// import LockOverlay from "../../../../components/LockOverlay";

interface PanelProps {
  title: string | React.ReactNode;
  children: React.ReactNode;
  variant?: "success" | "fail" | "info" | "default" | "warning";
  isLoading?: boolean;
  sx?: React.CSSProperties;
  tooltip?: string;
  titleUnderlined?: boolean;
  lock?: boolean;
  asin?: string;
  lookupId?: string;
  onClickTitle?: () => void;
}

const BG_COLORS = {
  success: "#E9FBEF",
  info: "#EDF6FC",
  fail: "#F2DEDE",
  default: "#FFFFFF",
  warning: "#FFF4D9",
};

const FONT_COLORS = {
  success: "#047647",
  info: "#036AA3",
  fail: "#A94442",
  default: "#000000",
  warning: "#DAA520",
};

const Panel: React.FC<PanelProps> = ({
  title,
  variant = "default",
  children,
  isLoading = false,
  sx,
  tooltip,
  titleUnderlined = false,
  // lock = false,
  asin,
  lookupId,
  onClickTitle,
}) => {
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      sx={{
        borderRadius: "4px",
        border: "1px solid #C9C9C9",
        width: "100%",
        margin: 0,
        ...sx,
      }}
    >
      <Tooltip title={tooltip}>
        <Box
          sx={{
            bgcolor: "#F0F0F0",
            borderBottom: "1px solid #C9C9C9",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "4px 4px 0px 0px",
            minHeight: "18px",
            cursor: onClickTitle ? "pointer" : "inherit",
            userSelect: onClickTitle ? "none" : "inherit",
          }}
          onClick={onClickTitle}
        >
          <Typography
            variant="body2"
            sx={{
              color: "#0F1111",
              fontSize: "12px",
              fontWeight: 600,
              textTransform: "capitalize",
              textDecoration: titleUnderlined ? "underline" : "none",
              textDecorationStyle: "dotted",
              textUnderlineOffset: "2px",
            }}
          >
            {title}
          </Typography>
        </Box>
      </Tooltip>
      <Box
        sx={{
          bgcolor: BG_COLORS[variant],
          color: FONT_COLORS[variant],
          borderRadius: "0px 0px 4px 4px",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          minHeight: "20px",
          alignItems: "center",
          fontSize: "12px",
          fontWeight: 700,
          lineHeight: "18px",
          padding: "2px 4px",
          position: "relative",
        }}
      >
        {isLoading ? <CircularProgress size="sm" /> : children}
        {/* {lock && asin && (
          <LockOverlay hideLabel asin={asin} lookupId={lookupId} />
        )} */}
      </Box>
    </Box>
  );
};

export default Panel;
